import Vue from "vue";
import MetaInfo from 'vue-meta-info'
import "./registerServiceWorker";
import mixin from "./mixins/index";
import 'ant-design-vue/dist/antd.css'
import "./components/lazyAntd"
import App from "./App.vue";
import router from "./router";
import API from './api/index'

Vue.prototype.$API = API;

Vue.use(MetaInfo);
Vue.mixin(mixin);
Vue.config.productionTip = false;
Vue.prototype.globalData = {currentIndex:0};

new Vue({
  router,
  render: (h) => h(App),
  // 添加mounted，不然不会执行预编译
  mounted () {
    // document.dispatchEvent(new Event('render-event'))
  }
}).$mount("#app");

